// @boty/ui - Color palette configuration
// EXACT VALUES - DO NOT DEVIATE

import type { PaletteOptions } from '@mui/material/styles';

export const palette: PaletteOptions = {
  primary: {
    main: '#4f46e5', // Indigo - primary brand color
    light: '#6366f1',
    dark: '#4338ca',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#f97316', // Coral - accent/CTA color
    light: '#fb923c',
    dark: '#ea580c',
    contrastText: '#ffffff',
  },
  success: {
    main: '#14b8a6', // Teal - success states
    light: '#2dd4bf',
    dark: '#0d9488',
    contrastText: '#ffffff',
  },
  error: {
    main: '#ef4444', // Clear but friendly red
    light: '#f87171',
    dark: '#dc2626',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#f59e0b',
    light: '#fbbf24',
    dark: '#d97706',
    contrastText: '#000000',
  },
  info: {
    main: '#3b82f6',
    light: '#60a5fa',
    dark: '#2563eb',
    contrastText: '#ffffff',
  },
  background: {
    default: '#ffffff',
    paper: '#ffffff',
  },
  text: {
    primary: '#1f2937',
    secondary: '#6b7280',
    disabled: '#9ca3af',
  },
};
